const upsellObserver = new MutationObserver((_, obs) => {
  const upsell = document.querySelector('#lb-addon-popup-container-id');
  const divToAppend = document.querySelector('.lb-shared-product-card-cont');

  if (!divToAppend) return;

  const listItem1 = document.createElement('li');
  listItem1.textContent = 'The Luma water bottle uses UV-C light technology to eliminate 99.9% of bacteria from your water in just 60 seconds.';
  
  const listItem2 = document.createElement('li');
  listItem2.textContent = 'Your Aquavis water is chlorine free, which is great for taste and health, but not so great for the traditional water bottle you haul around all day. Without chlorine, your traditional water bottle builds up mold and bacteria, which is not great for taste and health.';
  
  const list = document.createElement('ul');
  list.appendChild(listItem1);
  list.appendChild(listItem2);

  const upsellBottomText = document.querySelector('#upsellBottomText').value;
  const ulElement = document.createElement('div');
  ulElement.innerHTML = upsellBottomText;

  if (upsell && divToAppend) divToAppend.insertAdjacentElement("afterend", ulElement);
  
  obs.disconnect();
});

upsellObserver.observe(document, {
  childList: true,
  subtree: true,
  attributes: true,
  characterData: true
});